// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__36PO6","subheader":"ReorderModal_subheader__2yF55","listWrap":"ReorderModal_listWrap__3QaKD"};